/* eslint-disable max-len */
import cn from 'classnames';
import React, { FC, useCallback, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Components } from 'src/configs/components/components';
import { useSessionRecorder } from 'src/hooks/use-session-recorder';
import { RootState } from '../../types/store-types';
import '../styles.scss';

type Props = {
  settings: any;
};
const HomePageConstructor: FC<Props> = ({ settings }) => {
  const location = useLocation();
  const currentUrl = `${window.location.origin}/${location.pathname}`;
  const sessionRecorder = useSessionRecorder();

  const { sectionLoading } = useSelector((state: RootState) => state.app);
  const renderHomePageWidgets = useCallback((): JSX.Element => {
    const orderIndex: any = {};
    Object.keys(settings).forEach((key: string) => (orderIndex[`${key}`] = settings[key].priority));

    const widgetLine = Object.keys(settings)
      .sort((a: string, b: string) => orderIndex[a] - orderIndex[b])
      .filter((key: string) => key !== 'styles')
      .map((key: string, index: number) => {
        return React.createElement(Components[key], {
          settings: settings[key],
          key: `${key}_${index}`,
        });
      });
    return <>{widgetLine}</>;
  }, []);

  useEffect(() => {
    sessionRecorder?.trackEvent('Home page view');
  }, []);

  return (
    <div
      className={cn('home_container', {
        ['is-load']: !sectionLoading.includes(false),
      })}
    >
      {process.env.REACT_APP_WEBSITENAME === 'PapiGames' && (
        <HelmetProvider>
          <Helmet>
            <title>
              Papi Games - Cassino Online, Slots e Apostas Esportivas. Torneios Diários Gratuitos e Ganhe Dinheiro Real
            </title>
            <meta
              name="description"
              content="Participe de torneios gratuitos, jogue de graça e ganhe dinheiro real todos os dias! Os melhores jogos de cassino online, slots, jogos de cassino ao vivo e apostas esportivas estão em papi.bet.br"
            />
            <meta
              name="keywords"
              content="Participe de torneios gratuitos, jogue de graça e ganhe dinheiro real todos os dias! Os melhores jogos de cassino online, slots, jogos de cassino ao vivo e apostas esportivas estão em papi.bet.br"
            />
            <link rel="canonical" href={currentUrl} />
          </Helmet>
        </HelmetProvider>
      )}
      {renderHomePageWidgets()}
    </div>
  );
};
export default HomePageConstructor;
